export const reportingErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== 'object') return undefined
  const source = error as {
    status?: unknown
    response?: { status?: unknown }
  }
  if (typeof source.status === 'number') return source.status
  return typeof source.response?.status === 'number'
    ? source.response.status
    : undefined
}
